import {toTheme} from '@theme-ui/typography'
import {merge} from 'lodash/fp'

import * as modes from 'gatsby-theme-docz/src/theme/modes'
import prism from 'gatsby-theme-docz/src/theme/prism'
import styles from './styles'

const _extends = () => Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};

const _interopRequireDefault = (obj) => {
    return obj && obj.__esModule ? obj : {default: obj};
}

const _defineProperty = (obj, key, value) => {
    if (key in obj) {
        Object.defineProperty(obj, key, {value: value, enumerable: true, configurable: true, writable: true});
    } else {
        obj[key] = value;
    }
    return obj;
}

const _grayPercentage = require("gray-percentage");

const _grayPercentage2 = _interopRequireDefault(_grayPercentage);

const _typographyBreakpointConstants = require("typography-breakpoint-constants");

const _compassVerticalRhythm = require("compass-vertical-rhythm");

const _compassVerticalRhythm2 = _interopRequireDefault(_compassVerticalRhythm);

const typography = {
    title: "CitNOW",
    baseFontSize: "18px",
    baseLineHeight: 1.56,
    googleFonts: [
        {
            name: 'Open Sans',
            styles: [
                '300',
                '300i',
                '400',
                '400i',
                '600',
            ],
        },
        {
            name: 'Rubik',
            styles: [
                '300',
                '400',
                '500',
            ],
        },
    ],
    scaleRatio: 2.5,
    headerFontFamily: ['Rubik', 'sans-serif'],
    headerWeight: 500,
    blockMarginBottom: 2,
    bodyFontFamily: ['Open Sans', 'sans-serif'],
    bodyWeight: 400,
    boldWeight: 700,
    overrideStyles: function overrideStyles(_ref, options) {
        var scale = _ref.scale,
            rhythm = _ref.rhythm;

        var vr = (0, _compassVerticalRhythm2.default)({
            baseFontSize: "16px",
            baseLineHeight: "24.88px"
        });

        var styles = _defineProperty({
            "h1 a,h2 a,h3 a,h4 a,h5 a,h6 a": {
                fontFamily: options.headerFontFamily,
                fontWeight: options.headerWeight,
            },
            "h1,h2,h3,h4,h5,h6": {
                fontFamily: options.headerFontFamily,
                fontWeight: options.headerWeight,
            },
            blockquote: _extends({}, scale(1 / 5), {
                color: (0, _grayPercentage2.default)(40),
                paddingLeft: rhythm(3 / 4),
                marginLeft: 0,
                borderLeft: rhythm(1 / 4) + " solid " + (0, _grayPercentage2.default)(87)
            })
        }, _typographyBreakpointConstants.TABLET_MEDIA_QUERY, {
            html: _extends({}, vr.establishBaseline()),
            blockquote: {
                marginLeft: rhythm(-3 / 4),
                marginRight: 0,
                paddingLeft: rhythm(1 / 2)
            },
            table: _extends({}, scale(-1 / 5))
        });

        return styles;
    }
}

export default merge(toTheme(typography), {
    initialColorMode: 'light',
    // Show errors above playground editor
    showLiveError: true,
    // Show preview of the code inside playground
    showLivePreview: true,
    // Show editor when a playground is rendered
    showPlaygroundEditor: true,
    // Show dark/light mode switch toggle in header
    showDarkModeSwitch: false,
    // Display edit this page button on every page
    showMarkdownEditButton: false,
    // Wrap the playground editor and preview in iframes to avoid style/script collisions
    useScopingInPlayground: false,
    colors: {
        ...modes.light,
        modes: {
            dark: modes.dark,
        },
    },
    fonts: {
        monospace: 'Inconsolata',
    },
    fontSizes: [12, 14, 16, 20, 24, 32, 48, 64],
    fontWeights: {
        body: 400,
        heading: 700,
        bold: 700,
    },
    lineHeights: {
        body: 1.5,
        heading: 1.125,
    },
    letterSpacings: {
        body: 'normal',
        caps: '0.2em',
    },
    space: [0, 4, 8, 16, 32, 48, 64, 80, 100],
    radii: {
        square: 0,
        radius: 4,
        rounded: 10,
    },
    styles,
    prism,
})